import appstore from "../../appStore";
import { Dispatch } from "../Dispatch";

/** Consider to clear driver notes populated with selection of favourite addresses. This is called when an address is cleared from an address input field. */
export function ConsiderClearingDriverNotesFromFavourite(isPickup: boolean) {
    const bookingLocations = appstore.getState().booking.Locations;
    const pickupLocation = bookingLocations[0];
    const destinationLocation = bookingLocations[bookingLocations.length - 1];

    if (isPickup) {

        // cleared pickup address is not a favourite address - no need to proceed
        if (!pickupLocation.Favourite) return;

        // pickup driver notes is the exact note from the selected favourite address (not edited manually by the user)
        if (pickupLocation.Favourite.PickupNotes === pickupLocation.DriverNotes) {
            Dispatch.Booking.ClearDriverNotes(0);
        }

        // dropoff address from a favourite address is cleared first, but dropoff driver notes is not cleared because it was edited by the user.
        // then pickup address from a favourite address is cleared. there is no 'Dropoff driver notes' field in this case
        if (!destinationLocation.Favourite) Dispatch.Booking.ClearDriverNotes(1);
    }
    else {

        // cleared dropoff address is not a favourite address - no need to proceed
        if (!destinationLocation.Favourite) return;

        // dropoff driver notes is the exact note from the selected favourite address (not edited manually by the user)
        if (destinationLocation.Favourite.DropoffNotes === destinationLocation.DriverNotes) {
            Dispatch.Booking.ClearDriverNotes(1);
        }

        // pickup address from a favourite address is cleared first, 
        // then dropoff address from a favourite address is cleared, but dropoff driver notes is not cleared in the above check because it was edited by the user.
        // since both addresses are not from favourite addresses, there is no 'Dropoff driver notes' field in this case, and should be cleared even if it is edited by the user.
        if (!pickupLocation.Favourite) Dispatch.Booking.ClearDriverNotes(1);
    }
}